<template>
  <div
    class="bg-linear-to-r from-depth-2 to-depth-3 h-10 md:h-auto min-h-10 md:min-h-auto overflow-hidden transition-[min-height] duration-500 ease-in-out"
    :class="{ 'min-h-30': !md && isExpanded }"
  >
    <div
      v-if="hasSingleBenefit"
      data-testid="benefits-top-bar-wrapper"
      class="mx-auto max-w-screen-xl px-4 md:px-6"
    >
      <div class="flex justify-center md:justify-start">
        <landing-page-top-bar-item
          :benefit="benefits[0]"
          class="text-center md:text-left"
        />
      </div>
    </div>
    <div
      v-else
      data-testid="benefits-top-bar-wrapper"
      class="mx-auto flex max-w-screen-xl flex-col cursor-pointer px-4 md:flex-row md:cursor-default md:px-6"
      @click="toggleExpand"
    >
      <div
        v-for="(benefit, index) in benefits"
        :key="benefit.id"
        class="w-full md:flex-1 flex justify-center items-center md:items-start"
        :class="{
          'hidden md:block': index > 0 && !isExpanded,
          'md:mr-8': index < benefits.length - 1,
        }"
      >
        <div class="flex items-center w-full justify-center relative">
          <landing-page-top-bar-item
            :benefit="benefit"
            class="text-center md:text-left"
          />
          <div class="absolute right-0 md:hidden">
            <fa-icon
              v-if="index === 0"
              :icon="faChevronDown"
              data-testid="benefits-toggle"
              class="text-rhino transition-transform duration-500"
              :class="{ 'rotate-180': isExpanded }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import type { GetProductQuery } from '~/apollo/types/types';

const props = defineProps<{
  benefits: GetProductQuery['product_top_bar'];
}>();

const hasSingleBenefit = computed(() => props.benefits.length === 1);

const { md } = useAppBreakpoints();

const isExpanded = ref(false);

const toggleExpand = () => {
  if (md.value || hasSingleBenefit.value) return;
  isExpanded.value = !isExpanded.value;
};

watch(md, () => {
  isExpanded.value = false;
});
</script>
